export default __webpack_public_path__ + "static/2-9ff184bdf2c166f3212d12a689232263.jpeg";